<div class="NgxEditor__Seperator"></div>
<div class="NgxEditor__MenuItem NgxEditor__MenuItem--Text" (click)="openModal(emoji)"
    [ngClass]="{'NgxEditor__MenuItem--Active': isActive, 'NgxEditor--Disabled': isDisabled}">
    <i class="fa-solid fa-face-smile-wink text-warning ms-3 fa-1x" style="margin-top: 5px;" title="Emoji"></i>
</div>
<ng-template #emoji let-c="close" let-d="dismiss">
    <app-ngx-editor-emoji [editor]="editor" />
</ng-template>